import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "vivo-cookie-consent";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch {
      // localStorage unavailable — show banner anyway
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accepted_strictly_necessary: true, at: new Date().toISOString() })
      );
    } catch {
      // non-fatal
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie notice"
      className="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-4 pointer-events-none"
      data-testid="cookie-banner"
    >
      <div className="pointer-events-auto max-w-3xl mx-auto bg-card/95 backdrop-blur-lg border border-white/10 rounded-xl shadow-2xl p-3 sm:p-5 flex items-start gap-3 sm:gap-4">
        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
          <Cookie className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0 text-xs sm:text-sm">
          <p className="font-medium mb-0.5 sm:mb-1 text-foreground">Strictly necessary cookies only</p>
          <p className="text-muted-foreground text-[11px] sm:text-sm leading-snug">
            Vivo uses browser storage only to keep you logged in — no analytics or tracking.{" "}
            <Link to="/cookies" className="text-primary underline underline-offset-2" data-testid="cookie-banner-policy-link">Cookie Policy</Link>.
          </p>
        </div>
        <div className="flex gap-1 sm:gap-2 flex-shrink-0 items-center">
          <Button size="sm" onClick={dismiss} data-testid="cookie-banner-accept" className="h-8 px-3 text-xs sm:text-sm sm:h-9 sm:px-4">Got it</Button>
          <Button size="icon" variant="ghost" onClick={dismiss} aria-label="Dismiss" data-testid="cookie-banner-close" className="h-8 w-8">
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
